// extracted by mini-css-extract-plugin
module.exports = {"compWrap":"Personnel_compWrap__1yV7s","heading":"Personnel_heading__EuKbz","members":"Personnel_members__2PWGu","members2":"Personnel_members2__14ViB"};